import DoughnutLabel from "chartjs-plugin-doughnutlabel-v3";
import { Doughnut } from 'react-chartjs-2'
import {
    Chart,
    DoughnutController,
    registerables
} from "chart.js";
import { useTranslation } from 'react-i18next';
import { isIterableArray, pluginDoughnutBg, toFormatPrice } from '../../../utils/utils';
import { Typography } from '@material-tailwind/react';

import { classCharDoughnutContainerHeight } from "../common";
Chart.register(
    ...registerables,
    DoughnutController,
    DoughnutLabel,
);


const DoughnutGraph = ({ currentData, period, isEmpty, isMobile, graphId, getCalculateResultByArr, compareFunction }) => {

    const { t } = useTranslation()

    const getTotalByVal = function (arr, fixedCount, text) {
        const sum = arr.reduce(
            (acc, item, index) => {
                acc = acc + item
                return acc
            }, 0
        );
        return `${toFormatPrice(sum, fixedCount)} ${text ? text : ''}`;
    };



    const options = {
        plugins: {
            tooltip: {
                backgroundColor: '#fff',
                bodyColor: '#444248',
                titleColor: '#444248',
                titleSpacing: 8,
                caretSize: 0,
                cornerRadius: 12,
                borderColor: '#EDEDED',
                borderWidth: 2,
                padding: 16,
                titleFont: {
                    size: 18
                },
                bodyFont: {
                    size: 18
                },

                callbacks: {
                    title: function (tooltipItems) {
                        return tooltipItems[0].label
                    },
                    labelColor: function (context) {
                        return {
                            backgroundColor: context.dataset.backgroundColor[context.dataIndex],
                            border: 0,
                            boxWidth: 10,
                            boxHeight: 10,
                            pointStyle: 'circle',
                            useBorderRadius: true,
                            borderRadius: 5,
                        }
                    }
                }
            },
            legend: {
                display: false,
                position: 'bottom',
                align: 'center',
                labels: {
                    boxWidth: 8,
                    boxHeight: 8,
                    usePointStyle: true,
                    pointStyle: 'circle',
                    useBorderRadius: true,
                    borderRadius: 4,
                }
            },
            datalabels: {
                formatter: function (value, context) {
                    return `${toFormatPrice(value)}`;
                },
                color: function (context) {
                    return '#444248';
                },
                font: {
                    weight: 500,
                    size: isMobile ? 9 : 12,
                    family: 'Inter'
                }
            },
            doughnutLabel: {
                labels: [
                    {
                        text: t('analytics.dataTotalTitle'),
                        font: {
                            size: isMobile ? '9' : "12",
                            family: "Inter",
                            weight: "500",
                            lineHeight: 2
                        },
                        color: "#767579"
                    },
                    {
                        text: () => getTotalByVal(currentData.values, 2, t('grn')),
                        font: {
                            size: isMobile ? '11' : "14",
                            family: "Inter",
                            weight: "400",
                            lineHeight: 1.2
                        },
                        color: "#2D2B32"
                    },
                    {
                        text: period,
                        font: {
                            size: isMobile ? '9' : "12",
                            family: "Inter",
                            weight: "400",
                            lineHeight: 2
                        },
                        color: "#767579"
                    },
                    {
                        text: getCalculateResultByArr(currentData.compareValues1, currentData.compareValues2, compareFunction),
                        font: {
                            size: isMobile ? '9' : "12",
                            family: "Inter",
                            weight: "700",
                            lineHeight: 3
                        },
                        color: "#a546a2"
                    },
                ]
            }
        }
    }

    const data = {
        labels: isIterableArray(currentData?.labels) ? currentData.labels.map(label => t(`analytics.pie_${label}`)) : [],
        datasets: [
            {
                data: currentData.values,
                backgroundColor: currentData.colors,
                borderWidth: 0,
            },
        ],
        doughnutlabel: {
            display: true,
        }
    };


    return (
        <>
            {
                isEmpty ?
                    <div className={`flex items-center justify-center ${classCharDoughnutContainerHeight}`}>
                        <Typography variant='lead' className='text-[16px] lap:text-[20px] font-medium text-center my-[40px]'>
                            {t('analytics.month_detailing_no_data')}
                        </Typography>
                    </div>
                    :
                    <Doughnut
                        id={graphId}
                        updateMode='resize'
                        data={data}
                        options={options}
                        plugins={[pluginDoughnutBg]}
                    />
            }
        </>
    )
}

export default DoughnutGraph